<div class="component-box" *ngIf="isSearchVisible">
  <form (ngSubmit)="onSearch()" class="search-form">
    <div class="search-fields">
      <mat-form-field appearance="fill">
        <mat-label>User</mat-label>
        <input matInput [(ngModel)]="searchForm.changedBy" name="changedBy" placeholder="Search by user">
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Company ID</mat-label>
        <input matInput [(ngModel)]="searchForm.companyId" name="companyId" placeholder="Company GUID — includes related entities">
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>From Date</mat-label>
        <input matInput [matDatepicker]="fromPicker" [(ngModel)]="searchForm.changedAtFrom" name="changedAtFrom" placeholder="DD/MM/YYYY">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="fromPicker"></mat-datepicker-toggle>
        <mat-datepicker #fromPicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>To Date</mat-label>
        <input matInput [matDatepicker]="toPicker" [(ngModel)]="searchForm.changedAtTo" name="changedAtTo" placeholder="DD/MM/YYYY">
        <mat-hint>DD/MM/YYYY</mat-hint>
        <mat-datepicker-toggle matIconSuffix [for]="toPicker"></mat-datepicker-toggle>
        <mat-datepicker #toPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="search-actions">
      <button mat-flat-button color="primary" type="submit">
        <mat-icon>search</mat-icon>
        Search
      </button>
      <button mat-flat-button type="button" class="nrg-error-flat-button" (click)="clearSearch()">
        <mat-icon>clear</mat-icon>
        Clear
      </button>
    </div>
  </form>
</div>
